import { drawerCopy } from "./copy.ts";

export const drawer = {
  label: drawerCopy.item,
  links: [{ rel: "manifest", href: "/avisos/manifesto.json" }],
};
